import { render, staticRenderFns } from "./ChangeLogs.vue?vue&type=template&id=e1646c18"
import script from "./ChangeLogs.vue?vue&type=script&lang=ts"
export * from "./ChangeLogs.vue?vue&type=script&lang=ts"
import style0 from "./ChangeLogs.vue?vue&type=style&index=0&id=e1646c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports